import React from 'react';
import { QuestionRendererProps } from './types';
import { getQuestionTypeConfig } from '../../../config/questionTypeRegistry';
import { QuestionErrorBoundary } from '../QuestionErrorBoundary';
import { warn, error as logError } from '../../../utils/logger';
/**
 * QuestionRendererFactory
 *
 * Routes question type → renderer component, wrapped in a per-renderer
 * error boundary so a single renderer crash shows a skip-friendly message
 * instead of taking down the entire session.
 *
 * §6.1 STABILIZATION: Enhanced with renderer type logging and
 * descriptive reset handler for better crash diagnostics.
 */
export function QuestionRendererFactory(props: QuestionRendererProps) {
  const {
    question
  } = props;
  const questionType = question.questionType || 'multiple_choice';
  const config = getQuestionTypeConfig(questionType);
  const Renderer = config.Renderer;
  const rendererName = Renderer.displayName || Renderer.name || questionType;
  return <QuestionErrorBoundary questionId={question.id} onReset={() => {
    logError(`[RendererCrash] Renderer "${rendererName}" (type: ${questionType}) crashed for question ${question.id} (family: ${question.familyId ?? 'unknown'}, tier: ${question.tier ?? '?'})`);
    warn(`Question ${question.id} renderer "${rendererName}" crashed and was reset`);
  }} data-id="element-4977">
      <Renderer {...props} data-id="element-4978" />
    </QuestionErrorBoundary>;
}